// extracted by mini-css-extract-plugin
module.exports = {"recognised":"Recognised_recognised__C_qyP"};